import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { withStyles, Typography, Button } from '@material-ui/core'
import TextField from '../../../components/TextField'
import { parseTelefone } from '../../../utils/Parse'
import { validateTelephone, validateEmail } from '../../../utils/Validators'
import { CustomAutocomplete } from '../../../components'
import UploadField from '../../../components/UploadField'
import DropzoneField from '../../../components/DropzoneField'
import CustomFileViewer from '../../../components/CustomFileViewer'
import ObservacaoField from '../../../components/ObservacaoField'
import { Alert } from '@material-ui/lab'
import RFFReferenciaTransportadoraAutocomplete from '../../Solicitacoes/Referencias/RFFReferenciaTransportadoraAutocomplete'
import RFFTextField from '../../../components/RFFTextField'

const StatusReferenciaPessoal = {
  TELEFONEINCORRETO: 'Telefone incorreto',
  NAOATENDE: 'Não atende',
  RECUSADARINFORMACOES: 'Se recusa a dar informações',
  NAOCONHECENAOSABEINFORMACOES: 'Não conhece e/ou não sabe dar informações',
  NAOPOSSUIGRAUPARENTESCO: 'Não possui grau de parentesco',
  OK: 'Ok'
}

const StatusReferenciaComercial = {
  TELEFONEINCORRETO: 'Telefone incorreto',
  NAOATENDE: 'Não atende',
  RECUSADARINFORMACOES: 'Se recusa a dar informações',
  NAOPOSSUICADASTRO: 'Não possui cadastro',
  NAOPOSSUIHISTORICO: 'Não possui histórico',
  HISTORICODESATUALIZADO: 'Histórico desatualizado',
  HISTORICOOK: 'Histórico Ok'
}

const Parentesco = {
  PAI: 'Pai',
  MAE: 'Mãe',
  ESPOSO: 'Esposo',
  ESPOSA: 'Esposa',
  FILHO: 'Filho',
  FILHA: 'Filha',
  IRMAO: 'Irmão',
  IRMA: 'Irmã'
}

const styles = theme => ({
  root: {
    padding: theme.spacing(6)
  },
  title: {
    marginTop: theme.spacing(5)
  },
  marginTop: {
    marginTop: theme.spacing(6)
  }
})

const customTrim = str => {
  if (str) {
    return str.toString().trim()
  }
  return ''
}

const checkUnique = (item, items) => {
  let count = 0
  for (let i = 0; i < items.length; i++) {
    const it = items[i]
    if (it === item) count += 1
    if (count > 1) return false
  }
  return true
}

const validateReferenciaPessoal = (referencias, index, requerida) => {
  if (referencias && referencias[index]) {
    const referencia = referencias[index]
    return {
      nome: customTrim(referencia.nome) ? undefined : 'Obrigatório',
      parentesco: referencia.parentesco ? undefined : 'Obrigatório',
      telefone: checkUnique(
        referencia.telefone,
        referencias.map(r => r.telefone)
      )
        ? validateTelephone(referencia.telefone, referencia.telefone)
        : 'Telefone não é único'
    }
  }
  if (requerida) {
    return {
      nome: 'Obrigatório',
      parentesco: 'Obrigatório',
      telefone: 'Obrigatório'
    }
  }
}

const validateReferenciaComercial = (referencias, index, requerida) => {
  if (referencias && referencias[index]) {
    const referencia = referencias[index]
    return {
      nome: customTrim(referencia.nome) ? undefined : 'Obrigatório',
      email: validateEmail(referencia.email, false),
      telefone: checkUnique(
        referencia.telefone,
        referencias.map(r => r.telefone)
      )
        ? validateTelephone(referencia.telefone, referencia.telefone)
        : 'Telefone não é único'
    }
  }
  if (requerida) {
    return {
      nome: 'Obrigatório',
      telefone: 'Obrigatório'
    }
  }
}

export const validateReferencias = values => {
  const referenciasPessoais = []
  const referenciasComerciais = []
  for (let i = 0; i < 3; i++) {
    referenciasPessoais[i] = validateReferenciaPessoal(
      values.referenciasPessoais,
      i,
      true
    )
    referenciasComerciais[i] = validateReferenciaComercial(
      values.referenciasComerciais,
      i,
      true
    )
  }
  if (values.referenciasPessoais) {
    for (let i = 3; i < values.referenciasPessoais.length; i++) {
      referenciasPessoais[i] = validateReferenciaPessoal(
        values.referenciasPessoais,
        i
      )
    }
  }
  if (values.referenciasComerciais) {
    for (let i = 3; i < values.referenciasComerciais.length; i++) {
      referenciasComerciais[i] = validateReferenciaComercial(
        values.referenciasComerciais,
        i
      )
    }
  }
  return {
    referenciasPessoais,
    referenciasComerciais
  }
}

function ReferenciasForm({ form, classes, values, showError, cannotUpdate }) {
  const { id } = useParams()
  const isNew = /new/.test(id)

  const handleFileChange = (filePath, file) => {
    form.change(file, filePath)
  }

  const [rowsPessoal, setRowsPessoal] = useState(
    values.referenciasPessoais?.length || 3
  )
  const [rowsComercial, setRowsComercial] = useState(
    values.referenciasComerciais?.length || 3
  )

  const handleNomeReferenciaChange = (value, index) => {
    if (value) {
      form.change(
        `referenciasComerciais[${index}].telefone`,
        value.telefone || ''
      )
    }
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={4} justifyContent="center">
        {values?.renovado && (
          <Grid item xs={12}>
            <Alert severity="info">Renovação de Solicitação⠀</Alert>
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography id="referenciaspessoais" variant="h6" gutterBottom>
            Referências Pessoais
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {[...Array(rowsPessoal).keys()].map(i => (
            <Grid key={i} container spacing={4}>
              <Grid item xs={12} md={6}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={12}>
                    <Field
                      fullWidth
                      component={TextField}
                      label="Nome"
                      name={`referenciasPessoais[${i}].nome`}
                      showError={showError}
                      disabled={cannotUpdate || (!isNew && i < 3)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field
                      fullWidth
                      component={CustomAutocomplete}
                      hideEmpty
                      options={Object.values(Parentesco).map(parentesco => ({
                        label: parentesco,
                        value: parentesco
                      }))}
                      label="Parentesco"
                      name={`referenciasPessoais[${i}].parentesco`}
                      showError={showError}
                      disabled={cannotUpdate || (!isNew && i < 3)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <RFFTextField
                      fullWidth
                      label="Telefone"
                      name={`referenciasPessoais[${i}].telefone`}
                      showError={showError}
                      format={parseTelefone}
                      disabled={cannotUpdate || (!isNew && i < 3)}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={12}>
                    <Field
                      fullWidth
                      hideEmpty
                      disabled
                      component={CustomAutocomplete}
                      options={Object.keys(StatusReferenciaPessoal).map(
                        key => ({
                          value: key,
                          label: StatusReferenciaPessoal[key]
                        })
                      )}
                      label="Status"
                      name={`referenciasPessoais[${i}].status`}
                      showError={showError}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Field
                      fullWidth
                      disabled
                      component={TextField}
                      label="Observação"
                      name={`referenciasPessoais[${i}].observacao`}
                      showError={showError}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
        <Grid item xs={12}>
          <Grid container alignItems="flex-end" justifyContent="flex-end">
            <Grid item>
              <Button
                variant="outlined"
                className={classes.marginTop}
                disabled={rowsPessoal <= 3 || cannotUpdate}
                onClick={() => {
                  if (rowsPessoal > 3) setRowsPessoal(rowsPessoal - 1)
                }}
              >
                -
              </Button>
              <Button
                variant="outlined"
                className={classes.marginTop}
                onClick={() => {
                  setRowsPessoal(rowsPessoal + 1)
                }}
                disabled={cannotUpdate}
              >
                +
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography
            id="referenciascomerciais"
            className={classes.title}
            variant="h6"
          >
            Referências Comerciais
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {[...Array(rowsComercial).keys()].map(i => (
            <Grid key={i} container spacing={4}>
              <Grid item xs={12} md={6}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={12}>
                    <RFFReferenciaTransportadoraAutocomplete
                      label="Nome"
                      fullWidth
                      name={`referenciasComerciais[${i}].nome`}
                      disabled={cannotUpdate}
                      showError={showError}
                      onChange={value => handleNomeReferenciaChange(value, i)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field
                      fullWidth
                      component={TextField}
                      label="E-mail"
                      name={`referenciasComerciais[${i}].email`}
                      showError={showError}
                      disabled={cannotUpdate || (!isNew && i < 3)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <RFFTextField
                      fullWidth
                      label="Telefone"
                      name={`referenciasComerciais[${i}].telefone`}
                      showError={showError}
                      format={parseTelefone}
                      disabled={cannotUpdate || (!isNew && i < 3)}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={12}>
                    <Field
                      fullWidth
                      hideEmpty
                      disabled
                      component={CustomAutocomplete}
                      options={Object.keys(StatusReferenciaComercial).map(
                        key => ({
                          value: key,
                          label: StatusReferenciaComercial[key]
                        })
                      )}
                      label="Status"
                      name={`referenciasComerciais[${i}].status`}
                      showError={showError}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Field
                      fullWidth
                      disabled
                      component={TextField}
                      label="Observação"
                      name={`referenciasComerciais[${i}].observacao`}
                      showError={showError}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
        <Grid item xs={12}>
          <Grid container alignItems="flex-end" justifyContent="flex-end">
            <Grid item>
              <Button
                variant="outlined"
                className={classes.marginTop}
                disabled={rowsComercial <= 3 || cannotUpdate}
                onClick={() => {
                  if (rowsComercial > 3) setRowsComercial(rowsComercial - 1)
                }}
              >
                -
              </Button>
              <Button
                variant="outlined"
                className={classes.marginTop}
                onClick={() => {
                  setRowsComercial(rowsComercial + 1)
                }}
                disabled={cannotUpdate}
              >
                +
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.title} variant="h6">
            Comprovante de Viagens
          </Typography>
        </Grid>
        <Grid container spacing={4} justifyContent="flex-start">
          {isNew ? (
            <Grid item xs={12} sm={12} lg={4}>
              <Field
                accept=".jpg,.jpeg,.png,.pdf"
                component={UploadField}
                label="Comprovante de Viagens"
                name="comprovanteViagensInput"
                onFileChange={filePath =>
                  handleFileChange(filePath, 'comprovanteViagens')
                }
                showError={showError}
              />
            </Grid>
          ) : (
            <>
              <Grid item xs={12} sm={6} lg={4}>
                <Field
                  solicitacaoId={values.id}
                  accept=".jpg,.jpeg,.png,.pdf"
                  component={DropzoneField}
                  label="Comprovante de Viagens"
                  name="comprovanteViagensInput"
                  onFileChange={filePath =>
                    handleFileChange(filePath, 'comprovanteViagens')
                  }
                  showError={showError}
                  disabled={cannotUpdate}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <CustomFileViewer
                  newTab
                  label="Comprovante de Viagens"
                  filePath={values.comprovanteViagens}
                  fileType="pdf"
                />
              </Grid>
            </>
          )}
        </Grid>
        {/* Observacao */}
        <ObservacaoField
          value={values.observacaoReferencias}
          title="Observações Referências"
          placeholder="Escreva aqui observações sobre as referências"
          name="novaObservacaoReferencias"
          disabled={cannotUpdate}
        />
      </Grid>
    </div>
  )
}

export default withStyles(styles)(ReferenciasForm)
